import { render, staticRenderFns } from "./mobileFooter.vue?vue&type=template&id=5916ae5f&scoped=true&"
import script from "./mobileFooter.vue?vue&type=script&lang=js&"
export * from "./mobileFooter.vue?vue&type=script&lang=js&"
import style0 from "./mobileFooter.vue?vue&type=style&index=0&id=5916ae5f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5916ae5f",
  null
  
)

export default component.exports